import React, { useState, useEffect, useContext, useMemo } from "react";

import { getInicioMes, getFinalMes, getDecMes } from "../../../../../services/date.services";

import QueryMembers from "../../../../basics/query/members";
import FormatsUtils from "../../../../../services/FormatsUtils";
import ApiDocumentsInbound from "../../../../../api/fiscal/documents/ApiDocumentsInbound";

import { Grade, PageControl, TabSheet, GradeOpcoes, InputDate, InputText, InputDropDowList, InputDropDowList2 } from "../../../../../components";

import { Button, MenuItem, Grid } from "@material-ui/core";
import { AppContext } from "../../../../../App";

import SearchIcon from "@material-ui/icons/Search";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";

import DocumentsServiceDetails from "../documentsDetails";

import ApiTypes from "../../../../../api/system/types/ApiTypes";
import DocumentsChange from "../documentsChange";

import { AppOptionsContext } from "../../../../../components/main/main";
import ApiLayoutsFiles from "../../../../../api/system/layoutsFiles/ApiLayoutsFiles";
import InputDecimal from "../../../../../components/inputs/inputDecimal";
import ApiDocumentsTypes from "../../../../../api/basics/documentsTypes";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import TablePagination from "../../../../../components/grade/TablePagination";
import ApiAttributes from "../../../../../api/system/attributes/ApiAttributes";

const initialCondition = {
    receiver: {},
    type_document: "-",
    status: "-",
    number_in: "",
    date_due_less_equal: getFinalMes(getDecMes()),
    date_due_more_equal: getInicioMes(getDecMes()),
    total: 0,
};

export default function DocumentsInbound() {
    const { setLoading, showMessageError, showMessageInfo, showMessageConfirmation } = useContext(AppContext);
    const { setOptions, setTitle } = useContext(AppOptionsContext);

    const [idDetails, setIdDetails] = useState(null);
    const [openDetails, setOpenDetails] = useState(false);

    const [idInEdition, setIdInEdition] = useState(0);

    const [tabIndex, setTabIndex] = useState(0);
    const [dataSource, setDataSource] = useState([]);

    const [rowCount, setRowCount] = useState(0);
    const [rowPage, setRowPage] = useState(10);
    const [page, setPage] = useState(0);

    const [condition, setCondition] = useState(initialCondition);
    const [conditionApply, setConditionApply] = useState(initialCondition);

    const [typesDocument, setTypesDocument] = useState([]);
    const [attributesDocument, setAttributesDocument] = useState([]);
    const [documentsTypes, setDocumentsTypes] = useState([]);

    const metaData = useMemo(() => [
        {
            label: "Opções",
            render: (record) => {
                const options = [
                    { tipo: "details", label: "Detalhes", disabled: !record.amount_items && !record.amount_taxes && !record.amount_invoices },
                    { tipo: "remove", label: "Remover" },
                ];

                // Update
                if (record.status === "pending") {
                    options.push({ tipo: "update_itens_taxes", label: "Atualizar Documento" });
                }

                // Cancel
                if (record.status === "active") {
                    options.push({ tipo: "cancel", label: "Cancelar Documento" });
                }

                return (
                    <span>
                        <GradeOpcoes record={record} onClickOpcoes={onClickOptions} opcoes={options} />
                    </span>
                );
            },
        },
        { label: "Tipo", field: "type_document" },
        {
            label: "Estabelecimento",
            render: (record) => {
                if (!record.operation_third) {
                    return (
                        <>
                            {record.issuer_name}
                            <br />
                            Documento: {FormatsUtils().document(record.issuer_document, record.issuer_type)}
                        </>
                    );
                }

                return (
                    <>
                        {record.receiver_name}
                        <br />
                        Documento: {FormatsUtils().document(record.receiver_document, record.receiver_type)}
                    </>
                );
            },
        },
        { label: "Numero", field: "number" },
        { label: "Serie", field: "serial" },
        { label: "Data Emissão", field: "date_due", format: "date" },
        {
            label: "Valor Itens",
            field: "total_items",
            format: "float",
            decimal: 2,
            align: "right",
        },
        {
            label: "Valor Líquido",
            field: "total",
            format: "float",
            decimal: 2,
            align: "right",
        },
        {
            label: "Situação",
            render: (record) => {
                let situacao = "Pendente";
                switch (record.status) {
                    case "active":
                        situacao = "Ativa";
                        break;
                    case "cancelled":
                        situacao = "Cancelada";
                        break;
                    default:
                        break;
                }

                return <span> {situacao} </span>;
            },
        },
        {
            label: "Fornecedor",
            render: (record) => {
                if (!record.operation_third) {
                    return (
                        <>
                            {record.receiver_name}
                            <br />
                            Documento: {FormatsUtils().document(record.receiver_document, record.receiver_type)}
                        </>
                    );
                }

                return (
                    <>
                        {record.issuer_name}
                        <br />
                        Documento: {FormatsUtils().document(record.issuer_document, record.issuer_type)}
                    </>
                );
            },
        },
    ]);

    useEffect(() => {
        setTitle("Documentos Fiscais Recebidos (Mercadorias)");
        loadDataSource(0);

        // Types
        ApiTypes()
            .apiDefault.findAll({ entity_in: "documents,documents_items,documents_files,documents_taxes" })
            .then((rec) => {
                setTypesDocument(rec.data);
            });

        // Attributes
        ApiAttributes()
            .apiDefault.findAll({ entity_in: "documents,documents_items,documents_files,documents_taxes" })
            .then((rec) => {
                setAttributesDocument(rec.data);
            });

        // Types Documents
        ApiDocumentsTypes()
            .apiDefault.findAll({ type_nature: "goods" })
            .then((rec) => {
                setDocumentsTypes(rec.data);
            });

        return () => {
            setOptions(null);
        };
    }, []);

    const attributesDocumentItems = useMemo(() => {
        return attributesDocument.filter((rec) => rec.entity === "documents_items");
    }, [attributesDocument]);

    const documentsTypesFilter = useMemo(() => {
        const result = documentsTypes.map((rec) => {
            return {
                value: rec.id,
                text: rec.name,
            };
        });

        result.unshift({
            text: "Todos",
            value: "-",
        });

        return result;
    }, [documentsTypes]);

    const loadDataSource = async (newPage, newRowPage, newCondition) => {
        setLoading(true);

        // Condition
        const conditionCustom = makeCondition(newCondition || conditionApply);

        try {
            const result = await ApiDocumentsInbound().managerList({ page: newPage + 1, pageSize: newRowPage || rowPage, condition: conditionCustom });

            if (result.status) {
                setDataSource(result.data);
                setRowCount(result.info.total);
            } else {
                setDataSource([]);
                if (result.message) {
                    showMessageError(result.message);
                }
            }
        } catch (e) {
            showMessageError({ active: true, message: e.message });
        } finally {
            setLoading(false);
        }
    };

    const makeCondition = (newCondition, ignoreStatus) => {
        const result = {};

        // Branch
        if (newCondition.receiver?.id) {
            result.receiver_id = newCondition.receiver?.id;
        }

        // Date Due
        if (newCondition.date_due_less_equal) {
            result.date_due_less_equal = FormatsUtils().dateAnsi(newCondition.date_due_less_equal);
        }
        if (newCondition.date_due_more_equal) {
            result.date_due_more_equal = FormatsUtils().dateAnsi(newCondition.date_due_more_equal);
        }

        // Number
        if (newCondition.number_in) {
            result.number_in = newCondition.number_in
                .split(",")
                .map((rec) => Number(rec))
                .join(",");
        }

        // Total
        if (newCondition.total) {
            result.total = newCondition.total;
        }

        // Status
        if (!ignoreStatus && newCondition.status !== "-") {
            result.status = newCondition.status;
        }

        // Type Document
        if (newCondition.type_document !== "-") {
            result.type_document = newCondition.type_document;
        }

        return result;
    };

    const onClickOptions = (record, tipo) => {
        switch (tipo) {
            case "edit":
                setIdInEdition(record.id);
                break;
            case "details":
                setIdDetails(record.id);
                setOpenDetails(true);
                break;
            case "update_itens_taxes":
                onUpdateDocument(record.id);
                break;
            case "cancel":
                showMessageConfirmation("Confirma cancelamento do documento? Este processo é irreversível.", () => {
                    onCancelDocument(record.id);
                });
                break;
            case "remove":
                showMessageConfirmation(
                    "Confirma remoção do documento? Este processo é irreversível. Qualquer vinculo com o documento também será excluído/cancelado.",
                    () => {
                        onRemoveDocument(record.id);
                    }
                );
                break;
            default:
                break;
        }
    };

    /*const onGenerateInboundOrdersAndMovementsItems = async () => {
        const condition = makeCondition(conditionApply, true);

        setLoading(true);

        try {
            const result = await ApiDocumentsInbound().generateInboundOrdersAndMovementsItems(condition);

            if (result.status) {
                showMessageInfo(
                    <>
                        <li>Ordens Criadas: {result.data.created}</li>
                        <li>Mensagens:</li>
                        {result.message.map((msg) => {
                            return (
                                <>
                                    -{msg}
                                    <br />
                                </>
                            );
                        })}
                    </>
                );
            } else {
                if (result.message) {
                    showMessageError(result.message);
                }
            }
        } catch (e) {
            showMessageError(e.message);
        } finally {
            setLoading(false);
        }
    };*/

    const onUpdateDocument = async (id) => {
        setLoading(true);

        try {
            const result = await ApiDocumentsInbound().defineItemsAndTaxes({ id });

            if (result.status) {
                showMessageInfo(
                    <>
                        <strong>Registro {id} atualizado</strong>
                        <br />
                        <li>Registros atualizados: {result.data.updated}</li>
                        <li>Registros inconscistentes: {result.data.pending}</li>
                        <li>Mensagens:</li>
                        {result.message.map((msg) => {
                            return (
                                <>
                                    -{msg}
                                    <br />
                                </>
                            );
                        })}
                    </>
                );
            } else {
                if (result.message) {
                    showMessageError(result.message);
                }
            }
        } catch (e) {
            showMessageError(e.message);
        } finally {
            setLoading(false);
        }
    };

    const onCancelDocument = async (id) => {
        setLoading(true);

        try {
            const result = await ApiDocumentsInbound().cancel(id);

            if (result.status) {
                showMessageInfo("Documento cancelado com sucesso");
            } else {
                if (result.message) {
                    showMessageError(result.message);
                }
            }
        } catch (e) {
            showMessageError(e.message);
        } finally {
            setLoading(false);
        }
    };

    const onRemoveDocument = async (id) => {
        setLoading(true);

        try {
            const result = await ApiDocumentsInbound().apiDefault.remove(id);

            if (result.status) {
                showMessageInfo("Documento removido com sucesso");
            } else {
                if (result.message) {
                    showMessageError(result.message);
                }
            }
        } catch (e) {
            showMessageError(e.message);
        } finally {
            setLoading(false);
        }
    };

    /*const onUpdateDocuments = async () => {
        const condition = makeCondition(conditionApply, true);

        setLoading(true);

        try {
            const result = await ApiDocumentsInbound().defineItemsAndTaxes(condition);

            if (result.status) {
                showMessageInfo(
                    <>
                        <strong>Atualização efetuada com sucesso</strong>
                        <br />
                        <li>Total registros: {result.data?.count || 0}</li>
                        <li>Registros atualizados: {result.data?.updated || 0}</li>
                        <li>Registros inconscistentes: {result.data?.pending || 0}</li>
                        <li>Mensagens:</li>
                        {result.message.map((msg) => {
                            return (
                                <>
                                    -{msg}
                                    <br />
                                </>
                            );
                        })}
                    </>
                );
            } else {
                if (result.message) {
                    showMessageError(result.message);
                }
            }
        } catch (e) {
            showMessageError(e.message);
        } finally {
            setLoading(false);
        }
    };*/

    const onFinalize = async (updated) => {
        setTabIndex(0);
        setIdInEdition(0);

        if (updated) {
            loadDataSource(page);
        }
    };

    useEffect(() => {
        if (tabIndex === 0) {
            setOptions(
                <>
                    <TablePagination
                        rowCount={rowCount}
                        rowPage={rowPage}
                        page={page}
                        onPageChange={(event, newPage) => {
                            loadDataSource(newPage);
                            setPage(newPage);
                        }}
                        onRowsPerPageChange={(event) => {
                            loadDataSource(0, event.target.value);
                            setPage(0);
                            setRowPage(event.target.value);
                        }}
                    />
                </>
            );
        }
    }, [tabIndex, rowCount, rowPage, page]);

    /*const onExecuteImport = async (files, layout, documentTypeDefault) => {
        setLoading(true);

        try {
            const result = await ApiDocumentsInbound().receipt(files, layout, documentTypeDefault);

            if (result.status) {
                showMessageInfo(
                    <>
                        <strong>Importação efetuada com sucesso</strong>
                        <br />
                        <li>Total registros: {result.data.count}</li>
                        <li>Destinatários Criados: {result.data.customers_create}</li>
                        <li>Documentos Criados: {result.data.documents_create}</li>
                        <li>Mensagens:</li>
                        {result.message.map((msg) => {
                            return (
                                <>
                                    -{msg}
                                    <br />
                                </>
                            );
                        })}
                    </>
                );
            } else {
                if (result.message) {
                    showMessageError(result.message);
                }
            }
        } catch (e) {
            showMessageError(e.message);
        } finally {
            setLoading(false);
        }
    };*/

    return (
        <>
            <PageControl tabindex={tabIndex} onchangetab={(index) => setTabIndex(index)}>
                <TabSheet label="Mercadorias Recebidas">
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={4}>
                            <InputDropDowList2
                                value={condition.type_document}
                                onChangeValue={(e) => setCondition({ ...condition, type_document: e.target.value })}
                                data={documentsTypesFilter}
                                label={"Tipo Documento"}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <QueryMembers
                                title="Consulta Estabelecimentos"
                                roleMember="branch"
                                label="Estabelecimento"
                                value={condition.receiver}
                                onChangeValue={(data) => setCondition({ ...condition, receiver: data })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputDate
                                label="Data inicial"
                                value={condition.date_due_more_equal}
                                onChangeValue={(date) => setCondition({ ...condition, date_due_more_equal: date })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputDate
                                label="Data final"
                                value={condition.date_due_less_equal}
                                onChangeValue={(date) => setCondition({ ...condition, date_due_less_equal: date })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputText
                                label="Número(s) NF"
                                value={condition.number_in}
                                onChangeValue={(e) => setCondition({ ...condition, number_in: e.target.value })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputDecimal
                                label={"Valor Líquido"}
                                value={condition.total}
                                symbol="R$"
                                decimal={2}
                                onChangeValue={(valueNumber, value) => setCondition({ ...condition, total: valueNumber })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputDropDowList
                                defaultValue={0}
                                label="Situação"
                                value={condition.status}
                                onChangeValue={(e) => setCondition({ ...condition, status: e.target.value })}
                            >
                                <MenuItem value={"-"}>Todos</MenuItem>
                                <MenuItem value={"pending"}>Pendentes</MenuItem>
                                <MenuItem value={"active"}>Ativos</MenuItem>
                                <MenuItem value={"cancelled"}>Cancelados</MenuItem>
                            </InputDropDowList>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        {/*<Button
                            style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginLeft: "5px" }}
                            variant="contained"
                            size="small"
                            color="primary"
                            onClick={() => setOpenImport(true)}
                            startIcon={<BackupIcon fontSize="inherit" />}
                        >
                            Importar Arquivo(s)
                        </Button>
                        <Button
                            style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginLeft: "5px" }}
                            variant="contained"
                            size="small"
                            color="secondary"
                            onClick={() => {
                                onUpdateDocuments();
                            }}
                            startIcon={<UpdateIcon fontSize="inherit" />}
                        >
                            Atualizar Documentos
                        </Button>
                        <Button
                            style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginLeft: "5px" }}
                            variant="contained"
                            size="small"
                            type="primary"
                            onClick={() => {
                                onGenerateInboundOrdersAndMovementsItems();
                            }}
                            startIcon={<CloudDownloadIcon fontSize="inherit" />}
                        >
                            Gerar Ordem de Entrada/Estoque
                        </Button>*/}

                        <Button
                            style={{ float: "right", marginTop: "5px", marginBottom: "5px", marginRight: "5px" }}
                            variant="contained"
                            size="small"
                            type="primary"
                            onClick={() => {
                                loadDataSource(0, rowPage, condition);
                                setPage(0);
                                setConditionApply(condition);
                            }}
                            startIcon={<SearchIcon fontSize="inherit" />}
                        >
                            Pesquisar
                        </Button>
                        <Button
                            style={{ float: "right", marginTop: "5px", marginBottom: "5px", marginRight: "5px" }}
                            variant="contained"
                            size="small"
                            type="primary"
                            onClick={() => {
                                setCondition(initialCondition);
                            }}
                            startIcon={<DeleteSweepIcon fontSize="inherit" />}
                        >
                            Limpar
                        </Button>
                    </Grid>
                    <Grade dataSource={dataSource} metaData={metaData} disablepagination={true} />
                </TabSheet>
                <TabSheet label={idInEdition ? `Documento ${idInEdition}` : null} icon={idInEdition ? null : <AddCircleIcon />}>
                    <Grid container spacing={1}>
                        <DocumentsChange
                            id={idInEdition}
                            documentsTypes={documentsTypes}
                            typeOperationChange={"in"}
                            typeItemChange={"goods"}
                            onLoadRecord={() => setTabIndex(1)}
                            onFinalize={(updated) => onFinalize(updated)}
                            types={typesDocument}
                            showOptions={tabIndex === 1}
                        />
                    </Grid>
                </TabSheet>
            </PageControl>
            <DocumentsServiceDetails id={idDetails} open={openDetails} setOpen={setOpenDetails} setLoading={setLoading} attributes={attributesDocumentItems} />
        </>
    );
}
